import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import messages from '../../../messages';
import Actions from './Actions';
import Indicator from './Indicator';
import styles from './Merging.pcss';
const Merging = ({ setHeaderMessage })=>{
    useStyles(styles);
    useEffect(()=>{
        setHeaderMessage(messages.headers.mergingPatient);
        return ()=>{
            setHeaderMessage(messages.headers.mergePatients);
        };
    }, []);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "d-flex flex-column align-items-center",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "my-4",
                    children: /*#__PURE__*/ _jsx(Indicator, {})
                })
            }),
            /*#__PURE__*/ _jsx(Actions, {})
        ]
    });
};
export default Merging;
